// Helpers para manipular listas de bots do usuário

/**
 * Ordena bots pela display_order (quando definida) e, em seguida,
 * por nome/username para garantir ordem estável.
 */
export function sortBotsByDisplayOrder(rawBots) {
  const bots = Array.isArray(rawBots) ? rawBots : [];
  return [...bots].sort((a, b) => {
    const orderA = a?.display_order ?? 999999;
    const orderB = b?.display_order ?? 999999;
    if (orderA !== orderB) return orderA - orderB;

    const nameA = (a?.bot_username || a?.bot_name || "").toLowerCase();
    const nameB = (b?.bot_username || b?.bot_name || "").toLowerCase();
    return nameA.localeCompare(nameB);
  });
}

/**
 * Retorna apenas bots visíveis (is_hidden === false) já ordenados.
 */
export function getVisibleBots(rawBots) {
  const bots = Array.isArray(rawBots) ? rawBots : [];
  const visible = bots.filter(b => !b?.is_hidden);
  return sortBotsByDisplayOrder(visible);
}
